import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ContentTypeCard } from 'components/molecules'
import { GENERAL_EVENTS, SPORT_EVENTS } from 'constants/appConstants'

const RenderEventTypeCards = ({ item, itemHeight, handleStatus, contentType }) => {
  return (
    <Link to={`/${item.location || contentType === GENERAL_EVENTS ? GENERAL_EVENTS : SPORT_EVENTS}/${item.documentId}`}>
      <ContentTypeCard
        item={item}
        itemHeight={itemHeight}
        contentType={item.location || contentType === GENERAL_EVENTS ? GENERAL_EVENTS : SPORT_EVENTS}
        handleStatus={handleStatus}
      />
    </Link>
  )
}

RenderEventTypeCards.defaultProps = {
  itemHeight: '',
  handleStatus: () => {},
}

RenderEventTypeCards.propTypes = {
  item: PropTypes.object.isRequired,
  itemHeight: PropTypes.string,
  handleStatus: PropTypes.func,
  contentType: PropTypes.string.isRequired,
}

export default RenderEventTypeCards
